/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_001: Question = {
  id: 'multi-001-quartier-vert-ecoquartier',
  oldId: '62',
  title: 'Intégration du concept de « quartier vert / écoquartier » dans les documents de planification',
  number: '5.1',
  description: [''],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 12,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_multi_001_v2: Question = question_multi_001;
export const question_multi_001_v3: Question = question_multi_001;
